<template>
  <div class="column">
    <breadcrumbs></breadcrumbs>
    <title-block :title="'Gebouwen ' + project.name" :callback="GetOrRefreshData"></title-block>
    <b-select v-model="perPage" class="is-size-7 float-right">
      <option value="5">5 per pagina</option>
      <option value="10">10 per pagina</option>
      <option value="15">15 per pagina</option>
      <option value="20">20 per pagina</option>
      <option value="0">alles</option>
    </b-select>

    <b-table
      class="fsdtable"
      hoverable
      :checkable="admin"
      :checked-rows.sync="checkedRows"
      :data="buildings"
      default-sort-direction="asc"
      default-sort="name"
      :paginated="perPage > 0"
      :per-page="perPage"
      @click="row => rowClicked(row)"
    >
      <template>
        <b-table-column cell-class="pointer" field="name" label="Gebouw" sortable v-slot="props">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column
          cell-class="pointer"
          field="floorCount"
          label="# Verdiepingen"
          sortable
          numeric
          v-slot="props"
          >{{ props.row.floorCount }}</b-table-column
        >
        <b-table-column cell-class="pointer" field="zoneCount" label="# Zones" sortable numeric v-slot="props">{{
          props.row.zoneCount
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="openingCount" label="# Openingen" sortable numeric v-slot="props">{{
          props.row.openingCount
        }}</b-table-column>
        <b-table-column
          cell-class="pointer"
          field="lastModification"
          label="Laatste mutatie"
          sortable
          numeric
          v-slot="props"
          >{{ new Date(props.row.lastModification).toLocaleDateString('nl-NL') }}</b-table-column
        >
        <b-table-column cell-class="pointer" field="lastModification" label="Status" sortable v-slot="props">
          <span class="tag fixedwidth" :style="statusColor(props.row.lastModification)">{{
            statusText(props.row.lastModification)
          }}</span>
        </b-table-column>
      </template>
      <template slot="bottom-left" v-if="admin">
        <b>Totaal Geselecteerde Rijen</b>
        : {{ checkedRows.length }}
        <!-- <span style="padding-left: 20px">
          <button
            class="button field is-danger"
            @click="
              deleteRows(checkedRows)
              checkedRows = []
            "
            :disabled="!checkedRows.length"
          >
            <b-icon icon="close"></b-icon>
            <span>Delete Selectie</span>
          </button>
        </span> -->
        <span style="padding-left: 20px">
          <button class="button is-primary" @click="isComponentModalActive = true">Voeg Gebouw Toe</button>
        </span>
      </template>
    </b-table>

    <b-loading
      :is-full-page="true"
      :active="isLoading"
      @close="$store.commit('ISLOADING', false)"
      :can-cancel="true"
    ></b-loading>

    <section>
      <b-modal :active.sync="isComponentModalActive" has-modal-card>
        <building-modal
          :projectData="project"
          :createProjectBool="false"
          @close=";(isComponentModalActive = false), GetOrRefreshData()"
        ></building-modal>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import TitleBlock from '@/components/General/TitleBlock'
import { mapGetters, mapActions } from 'vuex'
import rmBtnMixin from '@/mixins/rmBtnMixin.js'
import projectService from '@/services/projectService.js'
import BuildingModal from '@/components/Projects/BuildingModal'

export default {
  components: {
    Breadcrumbs,
    TitleBlock,
    BuildingModal
  },
  mixins: [rmBtnMixin],

  data() {
    return {
      perPage: 15,
      checkedRows: [],
      isComponentModalActive: false,
      admin: false
    }
  },

  computed: {
    ...mapGetters(['buildings', 'project', 'isLoading', 'user', 'adminClaim']),
    projectId() {
      if (this.project) return this.project.projectId
      return this.$route.params.id
    }
  },
  watch: {
    buildings(newBuildings) {
      localStorage.setItem('buildings', JSON.stringify(newBuildings))
    }
  },

  mounted() {
    const defaultAmountOfRows = 15
    const rows = localStorage.getItem('pagedTableRows')
    this.perPage = rows || defaultAmountOfRows
    // if (localStorage.getItem('buildings') != (undefined || null)) {
    //   const chached = JSON.parse(localStorage.getItem('buildings'))
    //   if (chached[0].projectId == this.$route.params.id) {
    //     this.$store.commit('SET_BUILDINGS', chached)
    //   }
    // }
    // if (!this.buildings.length > 0) {
    this.GetOrRefreshData()
    // }
  },

  beforeDestroy() {
    localStorage.setItem('pagedTableRows', this.perPage)
  },

  methods: {
    ...mapActions(['getBuildingsAsync']),
    GetOrRefreshData() {
      this.checkAdmin()
      this.$store.dispatch('updateCrumbs', { name: 'ProjectOverview' })
      this.getBuildingsAsync(this.$route.params.id)
    },
    rowClicked(row) {
      this.$store.commit('SET_SELECTED_BUILDING', row)
      this.$router.push('/buildingoverview/' + this.projectId + '/' + row.buildingId)
    },
    statusColor(data) {
      const d = new Date(data)
      const now = new Date()
      const timeDiff = Math.abs(now.getTime() - d.getTime())
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
      if (diffDays < 100) return 'backgroundColor:#b2f068'
      if (diffDays < 200) return 'backgroundColor:#ffdd75'
      if (diffDays < 365) return 'backgroundColor:#ffba6d'
      return 'backgroundColor:#fe816d'
    },
    async checkAdmin() {
      let bool = false
      bool = await this.$store.dispatch('getProjectAdminClaim', this.projectId)
      this.admin = bool
    },
    statusText(data) {
      const d = new Date(data)
      const now = new Date()
      const timeDiff = Math.abs(now.getTime() - d.getTime())
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
      if (diffDays < 100) return '< 100 dagen'
      if (diffDays < 200) return '< 200 dagen'
      if (diffDays < 365) return '< 1 jaar'
      return '> 1 jaar'
    },
    async deleteRows(rows) {
      let res = ''
      if (rows.length < 1) {
        res = await this.deleteAlert('Gebouw')
      } else {
        res = await this.deleteAlert('Gebouwen')
      }
      if (res == 'deleted') {
        rows.forEach(async element => {
          await projectService.deleteBuilding(element.projectId, element.buildingId)
          this.GetOrRefreshData()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.clickable {
  cursor: pointer;
}
.clickable:hover {
  text-shadow: 1px 1px 2px #408eba;
  color: #2f4858;
}
.fixedwidth {
  width: 100px;
}
td {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/BuildingsProject.vue